import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _Image;
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.flat-map.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import ImageExtension from "../models/ImageExtension";
import Media from "../../../assets/js/Media";
import ImageSize from "./ImageSize";
export default class Image extends Media {
  constructor(data) {
    super(data);
    _defineProperty(this, "Id", {
      fieldName: 'image_id',
      content: null
    });
    _defineProperty(this, "ImageId", {
      fieldName: 'image_id',
      fieldTitle: 'Image Id',
      content: null
    });
    _defineProperty(this, "ImageName", {
      fieldName: 'image_name',
      fieldTitle: 'Image Name',
      content: null
    });
    _defineProperty(this, "width", {
      fieldName: 'width',
      content: null
    });
    _defineProperty(this, "height", {
      fieldName: 'height',
      content: null
    });
    _defineProperty(this, "ImageUrl", {
      fieldName: 'image_url',
      fieldTitle: 'Image Url',
      content: null
    });
    _defineProperty(this, "ImageExtension", {
      fieldName: 'image_extension',
      fieldTitle: 'Image Extension',
      content: null
    });
    _defineProperty(this, "ImageFolder", {
      fieldName: 'image_folder',
      fieldTitle: 'Image Folder',
      content: null
    });
    _defineProperty(this, "ImageOtherExtensions", {
      fieldName: 'image_other_extensions',
      fieldTitle: 'Image Other Extensions',
      model: ImageExtension,
      content: null
    });
    _defineProperty(this, "ImageProvider", {
      fieldName: 'location_status',
      fieldTitle: 'Image Provider',
      content: null
    });
    _defineProperty(this, "createdAt", {
      fieldName: 'created_at',
      content: null
    });
  }
  getProvider() {
    return this.ImageProvider.content;
  }
  isProvidedByCloudFlare() {
    return this.getProvider() === Media.CLOUDFLARE_LOCATION_STATUS;
  }
  getId() {
    var _this$ImageId;
    return (_this$ImageId = this.ImageId) === null || _this$ImageId === void 0 ? void 0 : _this$ImageId.content;
  }
  getOfferImageUrl() {
    var _this$ImageUrl;
    return (_this$ImageUrl = this.ImageUrl) === null || _this$ImageUrl === void 0 ? void 0 : _this$ImageUrl.content;
  }
  getImageUrl() {
    var _this$ImageUrl2;
    return (_this$ImageUrl2 = this.ImageUrl) === null || _this$ImageUrl2 === void 0 ? void 0 : _this$ImageUrl2.content;
  }
  getWidth() {
    return this.width.content;
  }
  getHeight() {
    return this.height.content;
  }
  getUrl() {
    var _this$ImageUrl3;
    return this.isProvidedByCloudFlare() ? this.getResizedImageUrl() : (_this$ImageUrl3 = this.ImageUrl) === null || _this$ImageUrl3 === void 0 ? void 0 : _this$ImageUrl3.content;
  }
  getResizedImageUrl(options = {}) {
    var _options, _options$w, _options2;
    options = (_options = options) !== null && _options !== void 0 ? _options : {};
    options.w = (_options$w = options.w) !== null && _options$w !== void 0 ? _options$w : 'auto';
    let joinedOptions = Object.keys((_options2 = options) !== null && _options2 !== void 0 ? _options2 : {}).map(k => [k, options[k]].join('=')).join();
    let image = this.ImageUrl.content;
    return this.isProvidedByCloudFlare() ? [image, joinedOptions].join('/') : image;
  }
  getPreviewImage() {
    return this.getUrl();
  }
  getExtensions() {
    var _this$ImageOtherExten;
    return (_this$ImageOtherExten = this.ImageOtherExtensions.content) !== null && _this$ImageOtherExten !== void 0 ? _this$ImageOtherExten : [];
  }
  getCreationDate() {
    return this.createdAt.content;
  }
  getRecommendedImageSize(width) {
    var _this$getExtensions$f;
    return (_this$getExtensions$f = this.getExtensions().flatMap(extension => {
      if (!(extension instanceof ImageExtension)) return null;
      let recommendedWith = Number(width);
      let sizes = extension.getSizes();
      let closestSizeWidth = null;
      let closestSizeDiff = sizes.reduce((diff, size) => {
        if (!(size instanceof ImageSize)) return diff;
        let nextDiff = Number(size.getWidth()) - recommendedWith;
        return nextDiff >= 0 ? nextDiff < diff || !diff && diff !== 0 ? nextDiff : diff : diff;
      }, null);
      if (closestSizeDiff !== null && closestSizeDiff >= 0) {
        closestSizeWidth = closestSizeDiff + recommendedWith;
        let size = sizes.find(size => size instanceof ImageSize && Number(size.getWidth()) === closestSizeWidth);
        if (size instanceof ImageSize) return size;
      }
      return new ImageSize({
        path: extension.getPath(),
        width: extension.getWidth(),
        height: extension.getHeight()
      });
    })[0]) !== null && _this$getExtensions$f !== void 0 ? _this$getExtensions$f : null;
  }
}
_Image = Image;
_defineProperty(Image, "id_attribute_name", 'id');
_defineProperty(Image, "image_id_attribute_name", 'image_id');
_defineProperty(Image, "image_url_attribute_name", 'image_url');
_defineProperty(Image, "width_attribute_name", 'width');
_defineProperty(Image, "height_attribute_name", 'height');
_defineProperty(Image, "image_other_extensions_attribute_name", 'image_other_extensions');
_defineProperty(Image, "location_status_attribute_name", 'location_status');
_defineProperty(Image, "ATTRIBUTES", {
  [_Image.id_attribute_name]: null,
  [_Image.image_id_attribute_name]: null,
  [_Image.image_url_attribute_name]: null,
  [_Image.width_attribute_name]: null,
  [_Image.height_attribute_name]: null,
  [_Image.image_other_extensions_attribute_name]: 'ImageExtensionCollection',
  [_Image.location_status_attribute_name]: null
});
export { Image };